import { isMenu } from "@/utils/products";

export const SELF_SERVICE = "selfservice";

export function basketContainsServiceProductNotScanned(basket) {
  console.log("basketContainsServiceProductNotScanned");
  return basket.some(bi => {
    if (isMenu(bi)) {
      return bi.components.some(comp => {
        return (
          comp.selected.master_category_name !== SELF_SERVICE &&
          !comp.selected.scanned
        );
      });
    } else {
      return bi.master_category_name !== SELF_SERVICE && !bi.scanned;
    }
  });
}

export function basketContainsOnlyScannedProducts(basket) {
  return basket.every(bi => {
    if (isMenu(bi)) {
      return bi.components.every(comp => {
        return comp.selected.scanned;
      });
    } else {
      return bi.scanned;
    }
  });
}

export function basketContainsOnlySelfServiceProducts(basket) {
  return basket.every(bi => {
    if (isMenu(bi)) {
      return bi.components.every(comp => {
        return comp.selected.master_category_name === SELF_SERVICE;
      });
    } else {
      return bi.master_category_name === SELF_SERVICE;
    }
  });
}

export function basketContainsSelfServiceNotScanned(basket) {
  return basket.some(bi => {
    if (isMenu(bi)) {
      return bi.components.some(comp => {
        return (
          comp.selected.master_category_name === SELF_SERVICE &&
          !comp.selected.scanned
        );
      });
    } else {
      return bi.master_category_name === SELF_SERVICE && !bi.scanned;
    }
  });
}
